import BaseModel from '../BaseModel';
import ReferenceTermHighlights from '../ReferenceTermHighlights';

export default class PageInfo extends BaseModel {
  constructor(data = {}) {
    super(PageInfo, data);
    this.startCursor = data.startCursor;
    this.endCursor = data.endCursor;
    this.hasPreviousPage = data.hasPreviousPage;
    this.hasNextPage = data.hasNextPage;
    this.totalCount = data.totalCount;
    this.highlights =
      data.highlights &&
      data.highlights.map((h) => new ReferenceTermHighlights(h));
  }
}
